import { useState } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { Mask, useMaskedInputProps } from 'react-native-mask-input';

import { FormControlTextInput } from '../form-control-text-input';

import { MaskInputProps } from '.';

type NumberMaskInput = {
  label: string;
  placeholder: string;
  mask: Mask;
} & MaskInputProps;

export function NumberMaskInput(props: NumberMaskInput) {
  const [maskedNumber, setMaskedNumber] = useState(props.value);

  const { onChangeText, value: maskedValue } = useMaskedInputProps({
    value: maskedNumber,
    onChangeText: (masked, _unmasked) => {
      setMaskedNumber(masked);
      props.onChange(_unmasked);
    },
    mask: props.mask,
  });

  return (
    <FormControlTextInput
      style={styles.input}
      labelStyle={{ marginRight: 'auto' }}
      autoFocus={props.autoFocus}
      error={props.error ?? ''}
      label={props.label}
      placeholder={props.placeholder}
      keyboardType="number-pad"
      readOnly={props.readOnly}
      onChangeText={onChangeText}
      value={maskedValue}
      onBlur={props.onBlur}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    maxHeight: 48,
    width: '100%',
    ...Platform.select({
      web: {
        flex: 1,
      },
      default: {
        flex: 0,
      },
    }),
  },
});
